{
  "title": "Environmental performance analysis",
  "subtitle": "Avoided impact from your repairs, reuse and recycling, calculated with the LCA reference framework.",
  "actions": {
    "downloadReport": "Download report"
  },
  "filters": {
    "manufacturer": "Manufacturer"
  },
  "sheet": {
    "title": "Your environmental performance report",
    "description": "Because assessing a product’s value cannot be done alone, we brought together 5 companies to co-build a calculator based on field experience. Together, we defined a fair market reference framework aligned with operational realities. This living, evolving framework is enriched over time to guarantee increasingly precise estimates adapted to recycling and take-back challenges.",
    "sources": "Find all our sources:",
    "calculationReference": "Calculation reference framework",
    "ademeSources": "ADEME sources",
    "calculatorMethodology": "Calculator methodology note",
    "lcaMethodology": "LCA methodology note"
  },
  "cards": {
    "worldTour": "Avoided world tours",
    "co2": "Avoided CO2",
    "materials": "Unextracted raw materials"
  },
  "table": {
    "currentYear": "Number of files (current year)",
    "lastYear": "Previous year",
    "twoYearsAgo": "2 years ago",
    "impactMaterial": "Material impact (kg) (year n-1)",
    "impactCo2": "CO2 impact (kg) (year n-1)",
    "repair": "Repair",
    "repairEcosystem": "Calculated and referenced via ACV ECOSYSTEM - BOOMERANG",
    "repairProxy": "Studied via ADEME LCA proxy + other sources",
    "repairWithout": "Without prior study",
    "reuse": "Reuse",
    "reuseEcosystem": "Calculated and referenced via ACV ECOSYSTEM - BOOMERANG",
    "reuseProxy": "Studied via ADEME LCA proxy + other sources",
    "reuseWithout": "Without prior study",
    "recycled": "Recycling",
    "recycledByBoomerang": "Via BOOMERANG",
    "recycledByRepairer": "Other",
    "rental": "Rental",
    "withoutInformation": "Without information",
    "total": "Total"
  }
}
